import React, { memo } from 'react'
import { useTheme } from 'styled-components'

import * as S from './styles'

/**
 * @typedef {'success' | 'warning' | 'error' | 'info' | 'neutral' | 'critical'} BannerType
 */

/**
 * @typedef {'xs' | 'sm' | 'md' | 'lg' | 'xl' | number} RadiusType
 */

/**
 * @typedef {Object} BannerProps
 * @property {string} title
 * @property {BannerType} [type]
 * @property {RadiusType} [radius]
 * @property {React.ReactNode} [children]
 */

/**
 * @param {BannerProps} props
 */
function Banner({ title, type = 'error', radius = 'md', children }) {
  const theme = useTheme()

  return (
    <S.Banner
      title={title}
      backGround={theme.banner[type]}
      fontColor="#ffffff"
      radius={radius}
    >
      {children}
    </S.Banner>
  )
}

export default memo(Banner)
